import Vue from 'vue'
import Vuex from 'vuex'
import device from './device'
import login from './login'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    mobileMenuIsOpen: false,//移动端侧边栏是否打开
  },
  getters: {
    token: state => state.login.token,
  },
  mutations: {
    SET_MOBILE_MENU(state, isOpen) {
      state.mobileMenuIsOpen = isOpen
    }
  },
  actions: {
  },
  modules: {
    device,
    login
  }
})
